import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { EReducers, IReducers } from 'app/store/reducers';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { loadPipelines } from 'app/store/actions/pipeline.action';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { loadProducts } from 'app/store/actions/product.action';
import { addAProduct, refreshMeeting, updateAProduct } from 'app/store/actions/meeting.action';

import { DialogService } from 'app/shared/ui/dialog/dialog.service';

import { SessionService } from 'app/store/services/session.service';
import { IUserSessionData } from 'app/store/models/user.model';

import { EProductStateStatus, IProduct, IProductState } from 'app/store/models/product.model';
import { IPipeline, IPipelineState } from 'app/store/models/pipeline.model';

import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { PipelineService } from '../../store/services/pipeline.service';
import { TimezonePipe } from '../../shared/ui/pipes/timezone.pipe';
import { UtilitiesService } from '../../store/services/utilities.servive';
import { ISelectItem } from 'app/store/models/select.model';

@Component({
  selector: 'app-add-assoc-product',
  templateUrl: './add-assoc-product.component.html',
  styleUrls: ['./add-assoc-product.component.scss'],
})
export class AddAssocProductComponent implements OnInit, OnDestroy {
  @Input() data: any;
  @Input() action: string;

  products: IProduct[] = [];
  pipelines: IPipeline[] = [];
  defaultPipelines: string[] = [];;
  defaultPipelinesRequested: boolean;
  sessionData: IUserSessionData;
  initialSignature = '';
  editorConfig = {};
  startDate = new Date();
  formReady = false;
  inputForm: FormGroup;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private store: Store<IReducers>,
    private dialogService: DialogService,
    private sessionService: SessionService,
    private readonly pipelineService: PipelineService,
    private readonly utilService: UtilitiesService,
  ) {
  }

  getProductItems(): ISelectItem[] {
    if (!this.products) {
      return [];
    }
    return this.products.map(product => ({
      value: product.id,
      label: product.product_name,
    }));
  }


  getAssociatedProductItems(): ISelectItem[] {
    return [
      {
        label: 'Active',
        value: 0
      },
      {
        label: 'Won',
        value: 1
      },
      {
        label: 'Lost',
        value: 2
      }
    ];
  }

  get status(): number {
    return this.inputForm.get('status').value;
  }

  getPipelineItems(): ISelectItem[] {
    if (!this.pipelines.length) {
      return this.defaultPipelines.map(pipeline => ({
        value: pipeline,
        label: pipeline,
      }));
    }
    if (this.pipelines.length === 0) {
      return [];
    }
    return this.pipelines.map(pipeline => ({
      value: pipeline.id,
      label: pipeline.pipeline,
    }));
  }

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe((sessionData: IUserSessionData) => {
        this.sessionData = sessionData;
        this.store.dispatch(
          loadProducts({
            pagination: {
              current_page: 1,
              page_size: 10,
            },
          }),
        );
        this.store.dispatch(
          loadPipelines({
            pagination: {
              current_page: 1,
              page_size: 10,
            },
          }),
        );
        this.store
          .select(EReducers.PRODUCT)
          .pipe(takeUntil(this.destroy$))
          .subscribe((state: IProductState) => {
            if (state.status === EProductStateStatus.UPDATED) {
              this.store.dispatch(
                loadProducts({
                  pagination: state.pagination,
                }),
              );
            }

            if (state.products) {
              this.products = state.products.filter(
                item => item.enabled === true,
              );
              switch (this.action) {
                case 'new':
                  this.inputForm.addControl('user_product_id', new FormControl('', [Validators.required]));
                  this.inputForm.addControl('status', new FormControl(''));
                  setTimeout(() => this.formReady = true, 0);
                  break;
                case 'update':
                  this.store
                    .select(EReducers.PIPELINE)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe((pipelineState: IPipelineState) => {
                      if (pipelineState.pipelines) {
                        this.pipelines = pipelineState.pipelines;
                      }

                      if (
                        (!pipelineState.pipelines ||
                          pipelineState.pipelines.length === 0) &&
                        !this.defaultPipelines.length &&
                        !this.defaultPipelinesRequested
                      ) {
                        this.defaultPipelinesRequested = true;
                        this.pipelineService
                          .getPipelinesList(
                            {
                              current_page: 1,
                              page_size: 10,
                            },
                            true,
                          )
                          .subscribe(pipelineResponse => {
                            this.defaultPipelines = pipelineResponse.items;
                            this.defaultPipelinesRequested = false;
                          });
                      }

                      this.sessionData = sessionData;
                    });

                  this.initialSignature = this.data.product.description;
                  let upid = null;

                  this.products.forEach(item => {
                    if (item.product_name === this.data.product.name) {
                      upid = item.id;
                    }
                  });

                  let s = 0;
                  switch (this.data.product.current_status) {
                    case 'Won':
                      s = 1;
                      break;
                    case 'Lost':
                      s = 2;
                      break;
                  }

                  const pipe = new TimezonePipe(this.utilService);
                  if(upid !== null && this.inputForm.get('user_product_id') !== null) {
                    this.inputForm.get('user_product_id').setValue(upid);
                  }
                  if(s !== null && this.inputForm.get('status') !== null) {
                    this.inputForm.get('status').setValue(s);
                  }
                  this.inputForm.addControl('user_product_id', new FormControl(upid, [Validators.required]));
                  this.inputForm.addControl('status', new FormControl(s));
                  this.inputForm.addControl('description', new FormControl(
                    this.data.product.description,
                    [],
                  ));
                  this.inputForm.addControl('estimated_value', new FormControl(
                    this.data.product.est_value,
                    [],
                  ));
                  // tslint:disable-next-line:max-line-length
                  this.inputForm.addControl('estimated_date', new FormControl(
                    new Date(
                      this.data.product.est_close_date
                        ? pipe.transform(
                          this.data.product.est_close_date,
                          'YYYY-MM-DD',
                          this.utilService.getMomentTimezone(this.sessionData.time_zone),
                        )
                        : '',
                    ),
                    [],
                  ));
                  this.inputForm.addControl('pipeline', new FormControl(
                    Number(this.data.product.pipeline),
                    [],
                  ));
                  // tslint:disable-next-line:max-line-length
                  this.inputForm.addControl('status_date', new FormControl(
                    new Date(
                      this.data.product.status_date
                        ? pipe.transform(
                          this.data.product.status_date,
                          'YYYY-MM-DD',
                          this.utilService.getMomentTimezone(this.sessionData.time_zone),
                        )
                        : pipe.transform(
                          new Date(),
                          'YYYY-MM-DD',
                          this.utilService.getMomentTimezone(this.sessionData.time_zone),
                        ),
                    ),
                    [],
                  ));
                  this.inputForm.addControl('actual_value', new FormControl(
                    this.data.product.actual_value,
                    this.data.product.status === 0 ? [] : [Validators.required],
                  ));
                  this.inputForm.addControl('lost_reason', new FormControl(
                      this.data.product.lost_reason,
                  ));
                  // tslint:disable-next-line:max-line-length
                  this.inputForm.addControl('renewal_date', new FormControl(
                    new Date(
                      this.data.product.renewal_date
                        ? pipe.transform(
                          this.data.product.renewal_date,
                          'YYYY-MM-DD',
                          this.utilService.getMomentTimezone(this.sessionData.time_zone),
                        )
                        : '',
                    ),
                    [],
                  ));

                  setTimeout(() => this.formReady = true, 0);
                  break;
              }
            }
          });
      });
  }

  ngOnDestroy() {
  }

  submit() {
    if (!this.inputForm.valid) {
      this.inputForm.markAllAsTouched();
      return;
    }
    const form = this.inputForm.getRawValue();
    const pipe = new DatePipe('en-US');
    switch (this.action) {
      case 'new':
        if (this.inputForm.valid) {
          this.store.dispatch(
            addAProduct({
              meeting: {
                meeting_id: Number(this.data.meeting.id),
              },
              product: form,
            }),
          );
          setTimeout(() => {
          this.store.dispatch(
            refreshMeeting({
              id_meeting: Number(this.data.meeting.id),
            }),
          );
          }, 1000);
        } else {
          this.inputForm.markAllAsTouched();
          return false;
        }
        break;
      case 'update':
        const data = form;

        data.id = this.data.product.id;
        data.status = `${this.inputForm.get('status').value}`;
        data.actual_value = Number(data.actual_value);
        data.estimated_value = Number(data.estimated_value);

        if (moment(data.estimated_date).isValid()) {
          data.estimated_date = pipe.transform(
            data.estimated_date,
            'YYYY-MM-dd',
            this.utilService.getMomentTimezone(this.sessionData.time_zone),
          );
        } else {
          data.estimated_date = null;
        }

        if (moment(data.status_date).isValid()) {
          data.status_date = pipe.transform(
            data.status_date,
            'YYYY-MM-dd',
            this.utilService.getMomentTimezone(this.sessionData.time_zone),
          );
        } else {
          data.status_date = null;
        }

        if (moment(data.renewal_date).isValid()) {
          data.renewal_date = pipe.transform(
            data.renewal_date,
            'YYYY-MM-dd',
            this.utilService.getMomentTimezone(this.sessionData.time_zone),
          );
        } else {
          data.renewal_date = null;
        }

        for (const prop in data) {
          if (!data[prop]) {
            continue;
          }
          if (!data[prop]) {
            delete data[prop];
          }

          if (Array.isArray(data[prop])) {
            const resultArray = data[prop].filter(item => item);
            if (resultArray.length > 0) {
              data[prop] = resultArray;
            } else {
              delete data[prop];
            }
          }
        }

        this.store.dispatch(
          updateAProduct({
            meeting: {
              meeting_id: Number(this.data.meeting.id),
            },
            product: data,
          }),
        );
        break;
    }

    this.dialogService.close();
  }

  addProduct(product) {
    this.store.dispatch(
      addAProduct({
        meeting: {
          meeting_id: Number(this.data.meeting.id),
        },
        product,
      }),
    );
  }

  back() {
    this.dialogService.close();
  }

  onChangeSelect(event: any, field?: string) {
    if (field && field === 'status' && this.inputForm.get('actual_value') !== null) {
      if (event === 0) {
        this.inputForm.get('actual_value').setValidators([]);
        this.inputForm.get('actual_value').updateValueAndValidity();
      } else {
        this.inputForm.get('actual_value').setValidators([Validators.required]);
        this.inputForm.get('actual_value').updateValueAndValidity();
      }
      this.inputForm.updateValueAndValidity();
    }
  }

  onEditorInit() {
  }
}
